import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CryptoconvertService {
  constructor() {}

  convertOfferCode(text, mode) {
    let conversionOutput;
    try {
      if (mode == 'encrypt') {
        //encrypt
        let btoa = window.btoa(text);
        conversionOutput = btoa.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
      } else {
        conversionOutput = decodeURIComponent(escape(window.atob(text)));
      }
      return conversionOutput;
    } catch (error) {
      return 'INVALID_OFFER';
    }
  }
}
